import API from "../store/api";
import { setSSO, clearSSO } from '../store/actions/ssoActions';
import { authLogin, authLogout } from '../store/actions/authActions';
import { setMessage } from '../store/actions/dialogActions';

export const authUrl = (query, callback) => {
  return async dispatch => {
    API.get("/sso?user=" + query)
      .then((response) => {
        if (response?.status === 200) {
          dispatch(setSSO(response.body));
        } else {
          callback();
        }
      }).catch((error) => {
        callback();
      })
  }
}